import Select, { SelectProps } from 'antd/lib/select';
import { isEmpty, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
  getChildParList,
  getParList,
  getParListOffer,
  getParListProduct,
} from 'services/parametersService';

export type ParListSelectProps = SelectProps<any> & {
  parcode: string;
  parvalueparent?: string;
  prcode?: string;
  offerid?: number;
  allowClear?: boolean;
  modemultiple?: boolean;
  onSelected?: (val: any) => void;
  listTemp: any[];
  doccode: any;
};

const ParListTemplateLancode = (props: ParListSelectProps) => {
  const {
    parcode,
    parvalueparent,
    prcode,
    offerid,
    allowClear,
    modemultiple,
    onChange = noop,
    onSelected,
    listTemp,
    value,
    doccode,
    ...rest
  } = props;

  let [init, setInit] = useState(true);

  const { data: parList } = useQuery(
    ['getParList', { parcode }],
    () => getParList({ parcode,tpid:0 }).then((res) => res.list || []),
    {
      staleTime: MINUTE,
      enabled:
        parvalueparent === undefined &&
        prcode === undefined &&
        offerid === undefined,
    }
  );

  const { data: parListOffer } = useQuery(
    ['getParListOffer', { parcode, offerid }],
    () =>
      getParListOffer({
        parcode,
        offerid: offerid! ? offerid : ('' as any),
      }).then((res) => res.list || []),
    {
      staleTime: MINUTE,
      enabled:
        parvalueparent === undefined &&
        prcode === undefined &&
        offerid !== undefined,
    }
  );

  const { data: parListProduct } = useQuery(
    ['getParListProduct', { parcode, prcode }],
    () =>
      getParListProduct({ parcode, prcode: prcode! }).then(
        (res) => res.list || []
      ),
    {
      staleTime: MINUTE,
      enabled:
        parvalueparent === undefined &&
        prcode !== undefined &&
        offerid === undefined,
    }
  );

  const { data: childParList } = useQuery(
    ['getChildParList', { parcode, parvalueparent }],
    () =>
      getChildParList({ parcode, parvalueparent: parvalueparent! }).then(
        (res) => res.list || []
      ),
    { staleTime: MINUTE, enabled: parvalueparent !== undefined }
  );

  const listLangugeUsed = listTemp.map((value) => value.lancode);
  const options =
    parvalueparent !== undefined
      ? childParList
      : offerid !== undefined
      ? parListOffer
      : prcode !== undefined
      ? parListProduct
      : parList;

  const newOptions = options?.filter(
    (e) => !listLangugeUsed.includes(e.parvalue)
  );

  useEffect(() => {
    const defaultParListItem = newOptions?.find(
      ({ parflagdefault }) => parflagdefault
    );
    if (defaultParListItem && value === undefined) {
      if (!allowClear || init) {
        onChange(defaultParListItem?.parvalue, defaultParListItem as any);
        setInit(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, onChange, value, allowClear, listTemp]);

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(value);
    }
  };

  return !modemultiple ? (
    <Select
      allowClear={allowClear}
      onChange={handleChange}
      showSearch
      value={value}
      {...rest}
    >
      {newOptions?.map(({ parvalue, parlistlabel }, i) => (
        <Select.Option value={parvalue} key={i}>
          {doccode + ' ' + parlistlabel}
        </Select.Option>
      ))}
    </Select>
  ) : (
    <Select
      allowClear={allowClear}
      onChange={onChange}
      value={!isEmpty(value) ? value.filter((e: any) => e !== '') : []}
      {...rest}
      mode="multiple"
      placeholder="select one or more"
    >
      {newOptions?.map(({ parvalue, parlistlabel }, i) => (
        <Select.Option value={parvalue} key={i}>
          {doccode + ' ' + parlistlabel}
        </Select.Option>
      ))}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default ParListTemplateLancode;
